import React, { ReactNode } from 'react';
import { LabeledInput, SectionTitle } from '../fields';

import { WinRuleProps } from 'modules/tournaments/ui/components/form-parts/rules/types';

interface ExtendedWinRuleProps extends WinRuleProps {
  children?: ReactNode;
}

const WinBase: React.FC<ExtendedWinRuleProps> = ({ sportType = 'general', children }) => {
  return (
    <>
      <SectionTitle title="Победа" icon="🏆" tooltip="Настройка очков, которые получает команда за победу в разных сценариях." />

      <LabeledInput
        name="settings.winScore"
        placeholder="0 очков"
        label=""
        containerClassName="mb-4"
        inputContainerClassName="min-w-[120px]"
        alignRight={false}
        tooltip="Количество очков за победу в основное время матча"
        tooltipProps={{ position: 'input-right' }}
      />

      <LabeledInput
        name="settings.winScoreExtraTime"
        placeholder="0 очков"
        label="В дополнительное время"
        tooltip="Количество очков за победу, если матч завершился в дополнительное время (особенно важно в играх, где есть возможность ничьей)."
        tooltipProps={{ position: 'input-right' }}
      />

      {/* Место для дополнительных полей */}
      {children}
    </>
  );
};

export default WinBase;
